import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'

const LoadCompositionOrderNumber = ({
  idLoadComposition,
  idOrder
}) => (
  <div>
    <div className="negotiation-read-offer">
      <div className="negotiation-read-column">
        <span>{intl.get('menu.subMenuGeneral.loadComposition')}:</span>
        <span>{idLoadComposition}</span>
      </div>
    </div>
    <div className="negotiation-read-offer">
      <div className="negotiation-read-column">
        <span>{intl.get('planningDaily.order')}:</span>
        <span>{idOrder}</span>
      </div>
    </div>
  </div>
);

LoadCompositionOrderNumber.propTypes = {
  idLoadComposition: PropTypes.number.isRequired,
  idOrder: PropTypes.number.isRequired,
}

export default LoadCompositionOrderNumber
